import type { ReactNode } from "react";
import { RequireGuest as LibRequireGuest } from "@marekl/adminer/shell";

/** Redirects to /dashboard (or returnTo) if the user is already logged in. */
export function RequireGuest({ children }: { children: ReactNode }) {
  return (
    <LibRequireGuest returnTo={{ defaultPath: "/dashboard" }}>
      {children}
    </LibRequireGuest>
  );
}
